<div class="detail-order container-in-page">
    <app-detail-order></app-detail-order>
</div>